import "non.geist";
import "non.geist/mono";
import "./index.css";
import { Route, Switch } from "wouter";
import { Editor } from "@/components/Editor";
import { IframeViewer } from "@/components/IframeViewer";
import { NostrProvider } from "./components/NostrContext";
import { Home } from "./components/Home";
import { FloatingProfile } from "./components/FloatingProfile";

export function App() {
  return (
    <NostrProvider>
      <FloatingProfile />
      <Switch>
        <Route path="/hn/:id">{(params) => <IframeViewer id={params.id} />}</Route>
        <Route path="/editor" component={() => <Editor />} />
        <Route path="/">{() => <Home />}</Route>

        {/* Default route in a switch */}
        <Route>404: No such page!</Route>
      </Switch>
    </NostrProvider>
  );
}

export default App;
